import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import {
    NotificationPreferenceEntry,
    NotificationPreferences,
    SilenceDuration,
} from "@nova/schemas"

export type NotificationSettingsDraft = {
    entries: NotificationPreferenceEntry[]
    silence?: SilenceDuration
}

export const toNotificationSettingsDraft = (preferences: NotificationPreferences) => ({
    entries: preferences.entries,
})

type NotificationSettingsSlice = {
    draft: NotificationSettingsDraft | null
    isDirty: boolean
    isSavingChanges: boolean
}

const initialState: NotificationSettingsSlice = {
    draft: null,
    isDirty: false,
    isSavingChanges: false,
}

export const notificationSettingsSliceName = "notificationSettings" as const

export const {
    actions: { loadDraft, updateDraft, setIsSavingChanges, resetDraft },
    reducer: NotificationSettingsSliceReducer,
} = createSlice({
    name: notificationSettingsSliceName,
    initialState,
    reducers: {
        loadDraft: (state, action: PayloadAction<NotificationSettingsDraft>) => {
            state.draft = action.payload
            state.isDirty = false
        },
        updateDraft: (state, action: PayloadAction<NotificationSettingsDraft>) => {
            state.draft = action.payload
            state.isDirty = true
        },
        setIsSavingChanges: (state, action: PayloadAction<boolean>) => {
            state.isSavingChanges = action.payload
        },
        resetDraft: () => initialState,
    },
})

const root = (state: RootState) => state[notificationSettingsSliceName]

export const selectDraft = createSelector([root], (s) => s.draft)
export const selectIsDirty = createSelector([root], (s) => s.isDirty)
export const selectIsSavingChanges = createSelector([root], (s) => s.isSavingChanges)
